/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedSearchRouteImport } from './routes/_authed.search'
import { Route as AuthedProfileRouteImport } from './routes/_authed.profile'
import { Route as AuthedHomeRouteImport } from './routes/_authed.home'
import { Route as AuthedHistoryRouteImport } from './routes/_authed.history'
import { Route as AuthedFavoritesRouteImport } from './routes/_authed.favorites'
import { Route as AuthedAlbumsRouteImport } from './routes/_authed.albums'
import { Route as AuthedPlaylistIdRouteImport } from './routes/_authed.playlist.$id'
import { Route as AuthedAlbumIdRouteImport } from './routes/_authed.album.$id'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSearchRoute = AuthedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHomeRoute = AuthedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHistoryRoute = AuthedHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFavoritesRoute = AuthedFavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAlbumsRoute = AuthedAlbumsRouteImport.update({
  id: '/albums',
  path: '/albums',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPlaylistIdRoute = AuthedPlaylistIdRouteImport.update({
  id: '/playlist/$id',
  path: '/playlist/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAlbumIdRoute = AuthedAlbumIdRouteImport.update({
  id: '/album/$id',
  path: '/album/$id',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/signup': typeof SignupRoute
  '/albums': typeof AuthedAlbumsRoute
  '/favorites': typeof AuthedFavoritesRoute
  '/history': typeof AuthedHistoryRoute
  '/home': typeof AuthedHomeRoute
  '/profile': typeof AuthedProfileRoute
  '/search': typeof AuthedSearchRoute
  '/album/$id': typeof AuthedAlbumIdRoute
  '/playlist/$id': typeof AuthedPlaylistIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/signup': typeof SignupRoute
  '/albums': typeof AuthedAlbumsRoute
  '/favorites': typeof AuthedFavoritesRoute
  '/history': typeof AuthedHistoryRoute
  '/home': typeof AuthedHomeRoute
  '/profile': typeof AuthedProfileRoute
  '/search': typeof AuthedSearchRoute
  '/album/$id': typeof AuthedAlbumIdRoute
  '/playlist/$id': typeof AuthedPlaylistIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/signup': typeof SignupRoute
  '/_authed/albums': typeof AuthedAlbumsRoute
  '/_authed/favorites': typeof AuthedFavoritesRoute
  '/_authed/history': typeof AuthedHistoryRoute
  '/_authed/home': typeof AuthedHomeRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/search': typeof AuthedSearchRoute
  '/_authed/album/$id': typeof AuthedAlbumIdRoute
  '/_authed/playlist/$id': typeof AuthedPlaylistIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/onboarding'
    | '/signup'
    | '/albums'
    | '/favorites'
    | '/history'
    | '/home'
    | '/profile'
    | '/search'
    | '/album/$id'
    | '/playlist/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/onboarding'
    | '/signup'
    | '/albums'
    | '/favorites'
    | '/history'
    | '/home'
    | '/profile'
    | '/search'
    | '/album/$id'
    | '/playlist/$id'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/onboarding'
    | '/signup'
    | '/_authed/albums'
    | '/_authed/favorites'
    | '/_authed/history'
    | '/_authed/home'
    | '/_authed/profile'
    | '/_authed/search'
    | '/_authed/album/$id'
    | '/_authed/playlist/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/search': {
      id: '/_authed/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthedSearchRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/home': {
      id: '/_authed/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthedHomeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/history': {
      id: '/_authed/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AuthedHistoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/favorites': {
      id: '/_authed/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof AuthedFavoritesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/albums': {
      id: '/_authed/albums'
      path: '/albums'
      fullPath: '/albums'
      preLoaderRoute: typeof AuthedAlbumsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/playlist/$id': {
      id: '/_authed/playlist/$id'
      path: '/playlist/$id'
      fullPath: '/playlist/$id'
      preLoaderRoute: typeof AuthedPlaylistIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/album/$id': {
      id: '/_authed/album/$id'
      path: '/album/$id'
      fullPath: '/album/$id'
      preLoaderRoute: typeof AuthedAlbumIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAlbumsRoute: typeof AuthedAlbumsRoute
  AuthedFavoritesRoute: typeof AuthedFavoritesRoute
  AuthedHistoryRoute: typeof AuthedHistoryRoute
  AuthedHomeRoute: typeof AuthedHomeRoute
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedSearchRoute: typeof AuthedSearchRoute
  AuthedAlbumIdRoute: typeof AuthedAlbumIdRoute
  AuthedPlaylistIdRoute: typeof AuthedPlaylistIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAlbumsRoute: AuthedAlbumsRoute,
  AuthedFavoritesRoute: AuthedFavoritesRoute,
  AuthedHistoryRoute: AuthedHistoryRoute,
  AuthedHomeRoute: AuthedHomeRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedSearchRoute: AuthedSearchRoute,
  AuthedAlbumIdRoute: AuthedAlbumIdRoute,
  AuthedPlaylistIdRoute: AuthedPlaylistIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
